module.exports = __webpack_public_path__ + "img/24.eac24978.jpg";